/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { css, cva } from "@panda/css";
import { RecipeVariantProps } from "@panda/types";
import { useMemo } from "react";
import { useCosmosComponentContext } from "../context/ComponentContext";

export const sectionPaddingBlockStartCva = cva({
	variants: {
		paddingBlockVariant: {
			default: {
				lg: {
					paddingBlockStart: "eds.dimension.80",
				},
				lgDown: {
					paddingBlockStart: "eds.dimension.40",
				},
			},
			compact: {
				lg: {
					paddingBlockStart: "eds.dimension.32",
				},
				lgDown: {
					paddingBlockStart: "eds.dimension.20",
				},
			},
		},
	},
	defaultVariants: {
		paddingBlockVariant: "default",
	},
});

export type PaddingBlockVariants = NonNullable<
	RecipeVariantProps<typeof sectionPaddingBlockStartCva>
>["paddingBlockVariant"];

export const sectionPaddingBlockEndCva = cva({
	variants: {
		paddingBlockVariant: {
			default: {
				lg: {
					paddingBlockEnd: "eds.dimension.80",
				},
				lgDown: {
					paddingBlockEnd: "eds.dimension.40",
				},
			},
			compact: {
				lg: {
					paddingBlockEnd: "eds.dimension.32",
				},
				lgDown: {
					paddingBlockEnd: "eds.dimension.20",
				},
			},
		},
	},
	defaultVariants: {
		paddingBlockVariant: "default",
	},
});

export const sectionPaddingInlineCss = css({
	paddingInline: "eds.dimension.80",
	xxlDown: {
		paddingInline: "eds.dimension.64",
	},
	lgDown: {
		paddingInline: "eds.dimension.40",
	},
	mdDown: {
		paddingInline: "eds.dimension.32",
	},
	smDown: {
		paddingInline: "eds.dimension.16",
	},
});

/**
 * Custom hook to get the effective padding block variant from context
 * @param override - Optional override variant to use instead of context
 * @returns The effective padding block variant to use
 */
export const usePaddingBlockVariant = (override?: PaddingBlockVariants): PaddingBlockVariants => {
	const { paddingBlockVariant: contextPaddingBlockVariant } = useCosmosComponentContext();

	return useMemo(() => {
		return override || contextPaddingBlockVariant || "default";
	}, [override, contextPaddingBlockVariant]);
};

/**
 * Custom hook to get the effective max width from context
 * @param override - Optional override max width to use instead of context
 * @returns The effective max width to use
 */
export const useMaxWidth = (override?: string): string => {
	const { maxWidth: contextMaxWidth } = useCosmosComponentContext();

	return useMemo(() => {
		return override || contextMaxWidth || "1440px";
	}, [override, contextMaxWidth]);
};

/**
 * 
 * To change paddingBlockVariant for specific page.tsx, use this example:
 * 
  import { componentContext } from "@site/context";
  const compactContext = { ...componentContext, paddingBlockVariant: "compact" };
  ...
  return <CosmosHeroAndSectionsPage
			{...props}
			params={params}
			searchParams={searchParams}
			slug={slug}
			hygraphLocales={hygraphLocales}
			componentContext={compactContext}
		/>;
	...
 */
